import React from "react";
import "./BlogPage.css";

function PostNevilleGoddard() {
  const post = {
    title: "Al Tuo Comando: Il Potere di Creare la Tua Realtà – Neville Goddard",
    date: "13 Gennaio 2025",
    content: `
      <p>Tra i testi più potenti e ispiratori di Neville Goddard, “Al Tuo Comando” è una guida pratica e filosofica che invita il lettore a comprendere il potere della sua immaginazione e fede. Questo piccolo ma denso capolavoro è un manuale per trasformare la tua realtà attraverso il riconoscimento della tua divinità interiore.</p>
      
      <h3>Introduzione</h3>
      <p>Pubblicato per la prima volta nel 1939, “Al Tuo Comando” espone l'idea rivoluzionaria che la coscienza è l'unica realtà. Goddard insegna che il mondo esterno è una proiezione del nostro stato interiore e che possiamo modellarlo a piacimento cambiando i nostri pensieri e sentimenti.</p>

      <h3>Temi Principali del Libro</h3>
      <ul>
        <li><b>La Coscienza è l’Unica Realtà:</b> La realtà fisica è il risultato delle tue convinzioni interiori. Cambia il tuo stato d'animo e il tuo mondo cambierà di conseguenza.</li>
        <li><b>Il Potere dell’Immaginazione:</b> L’immaginazione è lo strumento creativo più potente. Visualizzando il risultato desiderato come già realizzato, puoi attrarre quelle condizioni nella tua vita.</li>
        <li><b>La Fede Attiva:</b> La fede non è passiva, ma un atto deliberato di credere in ciò che ancora non si vede.</li>
      </ul>

      <h3>Applicare gli Insegnamenti</h3>
      <ol>
        <li><b>Visualizzazione Creativa:</b> Ogni giorno, dedica del tempo a immaginare vividamente i tuoi obiettivi come già raggiunti.</li>
        <li><b>Affermazioni Positive:</b> Usa frasi come “Io Sono abbondante” per allinearti con il tuo desiderio.</li>
        <li><b>Vivi nel Sentimento del Desiderio Realizzato:</b> Agisci e pensa come se il tuo desiderio fosse già stato esaudito.</li>
      </ol>

      <h3>Conclusione</h3>
      <p>“Al Tuo Comando” non è solo un libro, ma una chiamata all’azione per riscoprire il tuo potere creativo e trasformare la tua vita dall'interno. Neville Goddard ci ricorda che siamo i comandanti del nostro destino, capaci di manifestare qualsiasi cosa attraverso la fede, l’immaginazione e la consapevolezza.</p>
    `,
    image: "/images/al-tuo-comando-neville-goddard.jpg",
    amazonLinks: [
      {
        title: "Compra il Libro su Amazon",
        url: "https://amzn.to/4fWc9A8",
      },
    ],
  };

  return (
    <div className="main-content">
      {/* Titolo del post */}
      <h1 className="home-title">{post.title}</h1>
      <p className="blog-date">{post.date}</p>

      {/* Immagine rappresentativa */}
      <div className="blog-image-container">
        <img src={post.image} alt={post.title} className="blog-image" />
      </div>

      {/* Contenuto del post */}
      <div
        className="blog-content"
        dangerouslySetInnerHTML={{ __html: post.content }}
      ></div>

      {/* Link di affiliazione Amazon */}
      <div className="amazon-links">
        {post.amazonLinks.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-amazon"
          >
            {link.title}
          </a>
        ))}
      </div>

      {/* Pulsanti social */}
      <div className="button-container">
        <a
          href="https://www.youtube.com/channel/@FrequenzediSaggezzaStoica"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-icon youtube"
        >
          <i className="fab fa-youtube"></i>
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61571814955253"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-icon facebook"
        >
          <i className="fab fa-facebook"></i>
        </a>
        <a
          href="https://www.tiktok.com/@frequenze.di.sagg"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-icon tiktok"
        >
          <i className="fab fa-tiktok"></i>
        </a>
      </div>

      {/* Pulsante per tornare al blog */}
      <a href="/blog" className="btn-back">
        Torna al Blog
      </a>
    </div>
  );
}

export default PostNevilleGoddard;